import React from 'react';
import { BrowserRouter as Router, Route, Link, useNavigate } from 'react-router-dom';
import SocioData from '../../services/socio-service';
import './sociogram.css';
import toast from 'react-hot-toast';
import { FaEdit, FaTrash, FaUsers } from 'react-icons/fa';

export class ListSociograms extends React.Component {

  constructor() {
    super()
    this.state = {
      loading: true
    }
    this.groupSizeRef = React.createRef();
  }

  async componentDidMount() {
    try {
      const self = this;
      const { accessToken } = this.props;
      const list = await SocioData.getSociogramList(accessToken);
      this.setState({ 
        data: list,
        accessToken,
        principal: JSON.parse(atob(accessToken.split(".")[1])).sub,
        loading: false
      });
    } catch ( error ) {
      console.error(error)
      this.setState({
        error: true,
        loading: false
      });
    }
  }

  handleGroupSizeChange = event => {
    if( isNaN(event.target.value) ) {
      event.target.value = this.state.groupSize;
      return;
    }
    this.setState({
      groupSize: event.target.value
    });
  }

  delete = async (id) => {
    if ( confirm("Are you sure you want to delete this sociogram?") ) {
      try {
        const response = await SocioData.deleteSociogram(id, this.state.accessToken);
        toast.success(response);

        this.setState(prevState => ({
          data: prevState.data.filter(sociogram => sociogram.id !== id)
        }));
      } catch (error) {
        toast.error("Failed to delete sociogram");
      }
    }
  }

  handleGenerateGroups = (groupLink) => {
    if (this.state.groupSize === undefined) {
      toast.error('Please set a number for amount of people per group.');
      if (this.groupSizeRef.current) {
        this.groupSizeRef.current.focus();
        this.groupSizeRef.current.select();
      }
      return;
    }
    window.location.href = groupLink;
  }

  formatDate = (epochTime) => {
    if (!epochTime) return 'N/A';
    const date = new Date(epochTime);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading sociograms...</p>
        </div>
      );
    }

    let data = this.state.data;
    let rows = [];

    if( !this.state.data ){
      return (<div>
        <h1>No Sociogram Available</h1>
        <Link to="/create">
            <button
              className="btn btn-primary btn-block contact">
              Create New Sociogram
            </button>
        </Link>
      </div>);
    }

    for (var i=0; i < data.length; i++) {
      var socioLink = "/sociogram/" + data[i].id;
      var updateSocioLink = "/update/" + data[i].id;
      var groupLink = "/groups/" + data[i].id + "/" + this.state.groupSize;

      var personCount = 0;
      if( data[i].people )
        personCount = data[i].people.length;

      rows.push(<tr key={data[i].id}>
        <td>
          <Link to={socioLink}>
            {data[i].name}
          </Link>
        </td>
        <td className="icon-cell">
          <Link to={updateSocioLink} title="Update / Modify">
            <FaEdit className="icon-edit" />
          </Link>
        </td>
        <td className="icon-cell">
          <button 
            onClick={() => this.handleGenerateGroups(groupLink)}
            className="icon-button"
            title="Generate Groups">
            <FaUsers className="icon-groups" />
          </button>
        </td>
        <td>
          {this.formatDate(data[i].createdAt)}
        </td>
        <td>
          {personCount}
        </td>
        <td className="public-link">
          https://dev.hypersocio.com/entry/{data[i].id}/{this.state.principal}
        </td>
        <td className="icon-cell">
          <button
            type="button"
            onClick={this.delete.bind(this, data[i].id)}
            className="icon-button"
            title="Delete">
            <FaTrash className="icon-delete" />
          </button>
        </td>
      </tr>);
    }

    return (
      <div>
        <h1>Previous Sociogram:</h1>
        <Link to="/create">
            <button
              className="btn btn-primary btn-block contact">
              Create New Sociogram
            </button>
        </Link>
        |
        Options: Group Size <input type="text" ref={this.groupSizeRef} className="group-size" id="groupSize" name="groupSize" value={this.state.groupSize} onChange={this.handleGroupSizeChange} />
        <br />
        <br />
        <table>
          <tbody>
            <tr>
              <td>Name</td>
              <td>Update</td>
              <td>Groups</td>
              <td>Created</td>
              <td># People</td>
              <td>Public Website</td>
              <td>Delete</td>
            </tr>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }

  filterUsers(user,data){
    console.log("Filtering for user: " + user);
    return data.filter(
      function(data){ return data.personID == user }
    );
  }
}